import { render, staticRenderFns } from "./productunit.vue?vue&type=template&id=6303d10c&"
import script from "./productunit.js?vue&type=script&lang=js&"
export * from "./productunit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports